import React from 'react'
import classes from "./Footer.module.css";
import FooterLogo from '../../components/CbBillComponents/CbFooter';
const ReportFooter = ({ qrCodeId, className }) => {
    return (
        <div className={className}>
            <figure class="footer-logo">
                <figure className={classes.footerQrCode}>
                    <img id='barcode' alt="pos-pey-invoice" className={classes.qrCode} src={`https://api.qrserver.com/v1/create-qr-code/?data=${qrCodeId}&size=80x80&bgcolor=255-255-255`} alt="Qrcode" />

                </figure>
            </figure>

            <div className={`${classes.footerWrapper} print-footer`}>
                <p className={`${classes.footerText} footer-text`}>
                    Scan the QR code to install the Community Buddy App and join your community today!
                </p>
                <FooterLogo />
            </div>
        </div>
    )
}

export default ReportFooter